import {useAsync} from '@freckle/educator-entities/ts/common/hooks/use-async/index'
import {WithResources} from '@freckle/classroom/ts/common/components/with-resources'
import {useTeacher} from '@freckle/classroom/ts/hooks/use-teacher'
import {fetchReferrals} from '@freckle/classroom/ts/pages/referral-program/models/referral'
import {ReferralProgramComponent} from './referral-program'

export default function ReferralProgramHandler() {
  const teacher = useTeacher()
  const referrals = useAsync(fetchReferrals, 'fetchReferrals', [])

  return (
    <WithResources
      resources={{teacher, referrals}}
      render={data => {
        return <ReferralProgramComponent {...data} />
      }}
    />
  )
}
